"use client";

import { useState } from "react";
import { CookieBanner } from "./CookieBanner";
import { CookiePreferencesModal } from "./CookiePreferencesModal";
import { CookieConsentIndicator } from "./CookieConsentIndicator";

export interface CookieConsentSettings {
  bannerEnabled: boolean;
  policyVersion: string;
  bannerTitle: string;
  bannerText: string;
  bannerPosition: "bottom" | "top";
}

/**
 * Client coordinator for the cookie-consent UI — owns the "preferences modal
 * open" state shared by the banner and the floating indicator. Mounted once
 * in the public (site) layout.
 */
export function CookieConsent({ settings }: { settings: CookieConsentSettings }) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <CookieBanner settings={settings} onCustomize={() => setModalOpen(true)} />
      <CookieConsentIndicator
        bannerEnabled={settings.bannerEnabled}
        onOpen={() => setModalOpen(true)}
      />
      {modalOpen ? (
        <CookiePreferencesModal
          policyVersion={settings.policyVersion}
          onClose={() => setModalOpen(false)}
        />
      ) : null}
    </>
  );
}
